import type { ReactNode } from "react";

/** Stat tile grid (U15) — the `livegrid` k/v/s pattern that was hand-rolled on
 *  four pages while this component sat unused (the adoption-law cautionary
 *  tale). `v`/`s` accept nodes; numbers group en-IN automatically. */
export interface Stat {
  k: ReactNode;
  v: ReactNode;
  s?: ReactNode;
  /** hover tooltip (e.g. the exact number behind a humanized one) */
  title?: string;
}

export function StatGrid({ stats, style }: { stats: Stat[]; style?: React.CSSProperties }) {
  return (
    <div className="livegrid" style={{ marginBottom: 16, ...style }}>
      {stats.map((st, i) => (
        <div key={i}>
          <div className="k">{st.k}</div>
          <div className="v num" title={st.title}>
            {typeof st.v === "number" ? st.v.toLocaleString("en-IN") : st.v}
          </div>
          {st.s != null && <div className="s">{st.s}</div>}
        </div>
      ))}
    </div>
  );
}
